import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Field, FieldType } from '../../../../../types/FieldCommon';
import { multilineTextSx } from '../../../../../styles/sxStyling';
import { formatFieldValue } from '../../../../../utility/fieldUtils';
import DrawerSection from '../DrawerSection';

type Props = { fields: Field[] };

const multilineFieldSx = { ...multilineTextSx, maxHeight: 140, overflowY: 'auto' };

export default function CustomFieldsDisplay({ fields }: Props) {
  if (_.isEmpty(fields)) return null;

  return (
    <DrawerSection title="More Details">
      {_.map(fields, (field) => (
        <Box key={field.label}>
          <Typography variant="caption" color="text.secondary">
            {field.label}
          </Typography>

          <Typography variant="body2" sx={field.type === FieldType.MULTILINE ? multilineFieldSx : undefined}>
            {formatFieldValue(field)}
          </Typography>
        </Box>
      ))}
    </DrawerSection>
  );
}
